import { Component, Input, Injectable } from '@angular/core';
import { CellComponent, ColumnConfig } from 'material-dynamic-table';
import { UserInGrid } from './search-users-data-source';
import { Subject, Observable } from 'rxjs';
 
@Injectable()
export class MessageService {
    private message = new Subject<UserInGrid>();

    getMessage(): Observable<UserInGrid> {
        return this.message.asObservable();
    }
    
    updateMessage(message: UserInGrid) {
        this.message.next(message);
    }
}

@Component({
    selector: 'ld-edit-cell',
    template: `
        <button mat-icon-button (click)="editUser()">
            <mat-icon>edit</mat-icon>
        </button>`,
    styles: [`
        :host {
            float: right;
        }
    `]
})
export class EditCellComponent implements CellComponent {

    @Input()
    column: ColumnConfig;
 
    @Input()
    row: UserInGrid;
 
    constructor(private messageService: MessageService) {}
 
    editUser() {
        this.messageService.updateMessage(this.row)
    }
}